<template>
  <div id="the-story">
    <div class="story-container">
      <b-container class="story-container-inner">
        <h1>The Story</h1>
        <div class="separator" />
        <p class="no-margin">
          The month of May is dedicated to focusing on our mental health. <br /><br />
          In honor of Mental Health Awareness Month, the Chicago Cubs have
          collaborated with visual artist Efdot on a limited-edition collection
          that aims to raise awareness of the importance of mental health and
          provides a message of support to those who may be living with mental
          health conditions.
          <br /><br />
          Let’s end the stigma around mental health and encourage all to be
          comfortable speaking freely about their mental health conditions.
        </p>
        <div :class="`plyr-container ${firstPlay ? 'hide-controls' : ''}`">
          <div class="thin-border" />
          <vue-plyr
            ref="plyr"
            :options="{
              controls: !global.isMobile
                ? [
                    'rewind', // Rewind by the seek time (default 10 seconds)
                    'play', // Play/pause playback
                    'fast-forward', // Fast forward by the seek time (default 10 seconds)
                    'progress', // The progress bar and scrubber for playback and buffering
                    'current-time', // The current time of playback
                    'duration', // The full duration of the media
                    'mute', // Toggle mute
                    'volume', // Volume control
                    'captions', // Toggle captions
                    'settings', // Settings menu
                    'download', // Show a download button with a link to either the current source or a custom URL you specify in your options
                    'fullscreen', // Toggle fullscreen
                  ]
                : [
                    'play', // Play/pause playback
                    'progress', // The progress bar and scrubber for playback and buffering
                    'current-time', // The current time of playback
                    'duration', // The full duration of the media
                    'mute', // Toggle mute
                    'volume', // Volume control
                    'download', // Show a download button with a link to either the current source or a custom URL you specify in your options
                    'fullscreen', // Toggle fullscreen
                  ],
              settings: ['captions', 'quality'],
            }"
          >
            <div
              data-plyr-provider="youtube"
              :data-plyr-embed-id="'AYfnbbhheg4'"
            ></div>
          </vue-plyr>
          <svg width="45" height="49" viewBox="0 0 45 49" xmlns="http://www.w3.org/2000/svg" v-if="!playing && ready" @click="play()" v-bind:id="'custom-play'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M41.933 25.38L4 46.657a1.008 1.008 0 01-1.501-.88V3.222a1.008 1.008 0 011.501-.879l37.932 21.279a1.008 1.008 0 010 1.758z" fill-rule="nonzero" stroke="#FFF" stroke-width="4" fill="none"/></svg>
        </div>
        <div class="artist-img-container">
          <img
            data-aos="fade-up"
            data-aos-duration="500"
            id="artist-img"
            class="artist-img"
            :src="require('@/assets/images/bg/efdot-character.svg')"
          />
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "TheStory",
  data() {
    return {
      firstPlay: true,
      playing: false,
      ready: false,
    };
  },
  mounted() {
    this.$refs.plyr.player.on("ready", (data) => {
      setTimeout(() => {
        this.ready = true;
      }, 250);
    });
    this.$refs.plyr.player.on("play", (data) => {
      this.playing = true;
      this.firstPlay = false;
    });
    this.$refs.plyr.player.on("pause", (data) => {
      this.playing = false;
      this.firstPlay = false;
    });
  },
  methods: {
    play() {
      this.$refs.plyr.player.play();
    },
  },
  computed: {
    ...mapState(["global"]),
  },
};
</script>

<style lang="scss" scoped>
$video-width: calc((100vh - 100px) * 1.778);

#the-story {
  padding-left: 19px;
  padding-right: 19px;
  @media (max-width: $md) {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 50px;
  }
  .story-container {
    display: flex;
    background-image: url("~@/assets/images/bg/Texture.png");
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-position: center;
    position: relative;
  }
  .artist-img-container {
    transform: translateY(45px);
  }
  .artist-img {
    width: 304px;
    height: auto;
    max-width: 100%;
    margin-top: 50px;
    max-width: 80vw;
    // bottom: -45px;
    // left: 50%;
  }
  .story-container-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding-top: 93px;
    // padding-bottom: 108px;
    padding-left: 15px;
    padding-right: 15px;

    @media (max-width: $md) {
      padding-left: 20px;
      padding-right: 20px;
      padding-top: 48px;
      // padding-bottom: 44px;
    }
    h1 {
      font-family: Poppins-Bold;
      font-size: 34px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      line-height: 42px;
      text-transform: uppercase;
    }
    .separator {
      width: 115px;
      height: 4px;
      background: #eaeaea;
      margin-top: 15px;
      margin-bottom: 15px;
    }
    p {
      width: 852px;
      max-width: 100%;
      font-family: AvenirNext-Medium;
      font-size: 18px;
      color: #ffffff;
      text-align: center;
      line-height: 31px;
      margin-top: 60px;
      width: 750px;
    }
    .no-margin {
      margin: 0 !important;
      width: 750px;
      max-width: 100%;
    }
  }
  .plyr-container {
    position: relative;
    flex: 1;
    width: $video-width;
    max-width: 100%;
    margin-top: 38px;
    .thin-border {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border: 2px solid rgb(4, 28, 56);
      height: 100%;
      width: 100%;
      z-index: 98;
      pointer-events: none !important;
    }
    #custom-play {
      position: absolute;
      height: 47px;
      width: 42px;
      top: 50%;
      left: 50%;
      transform: translate((-50%, -50%));
      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>

